module.exports = __webpack_public_path__ + "img/2.1c954707.png";